import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { DialogBase, RentalInfo, RentalObjectInfo, RequestDetails,  } from 't4core';
import { RentalObjectSecurityCheckInfo } from '../../../../../projects/t4core/src/public-api';
import { CreateServiceRequestDialog, DialogService } from '../../../../t4common';


@Component({
  selector: 't4-SecurityCheckInfoDialog',
  templateUrl: 'securityCheckInfoDialog.html',
  styleUrls: ['./securityCheckInfoDialog.css']
})
export class SecurityCheckInfoDialog extends DialogBase implements OnInit {

  groupsControl = new FormControl([]);

  public processedRentals: RentalIssues[] = [];
  public filteredRentals: RentalIssues[] = [];
  public rentalsWithSpareParts: RentalsSparePart[] = [];

  public securityChecks: RentalObjectSecurityCheckInfo[];
  public amount: number = 0;

  public counters = {};

  public objectInfo: RentalObjectInfo;

  public aiInformations: AIInfo[] = [];

  public hasAIInfoForRental(rentalId: number | null | undefined): boolean {
    if (rentalId == null) return false;
    return this.aiInformations?.some(x => x?.rentalId === rentalId && x.shouldbeDisabled == false) ?? false;
  }

  public hasAIIssueInfoForRental(rentalId: number | null | undefined): boolean {
    if (rentalId == null) return false;
    return this.aiInformations?.some(x => x?.rentalId === rentalId && x.shouldbeDisabled == true) ?? false;
  }

  public rentalIssues = new Set<number>();
  public filteredRentalIssues = new Set<number>();

  public issueCategories = new Set<string>();

  public isBookingSeleceted: boolean = false;
  public bookingSelected: number;

  public isLoading: boolean = false;

  public rentalIds: number[] = [];

  constructor(public dialogRef: MatDialogRef<SecurityCheckInfoDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private dialogSvc: DialogService, private changeDetectorRef: ChangeDetectorRef) {
    super("SecurityCheckInfoDialog");
  }

  async ngOnInit() {
    var token = this.beginLoad("Turbo.Service.Dialogs.SecurityCheck.ldrSecurityCheck", "Preparing securitycheck...", null);
    this.isLoading = true;

    this.securityChecks = await this.Api.get<RentalObjectSecurityCheckInfo[]>("RentalObject/GetSecurityCheckOnRentalObject", { rentalObjectId: this.data.TrailerId });
    this.objectInfo = await this.Api.get<RentalObjectInfo>("RentalObject/GetObjectInfo", { objectId: this.data.TrailerId })
    this.amount = this.securityChecks.length;

    await this.processDataToList();
    await this.getSecurityCheckCount();

    this.getBookingWithSpareParts();

    this.endLoad(token);
    this.isLoading = false;

    this.processAIInfo();

    console.log(this.data);
    console.log(this.aiInformations);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }




  public async processDataToList() {
    this.objectInfo.Movements.forEach(r => {
      var item = this.processedRentals.find(x => x.rentalId == r.BookingId);
      if (!item) {
        item = { rentalId: r.BookingId, issues: [], remarks: [], pickupDate: r.StartTime, rentalStatus: r.Status };
        this.processedRentals.push(item);
      }
      this.securityChecks.filter(x => x.RentalId == r.BookingId).forEach(securityCheck => {
        if (securityCheck.JsonData && securityCheck.JsonData.trim() !== "") {
          const parsedData = JSON.parse(securityCheck.JsonData);
          for (const option of parsedData.securityChecks) {
            this.issueCategories.add(option.key)
          }

          for (const obj of parsedData.securityChecks.filter(x => !x.ok)) {
            if (!item.issues.some(x => x == obj.key))
              item.issues.push(obj.key);
          }


          if (parsedData.remarks) {
            var tempItem = new Remark();
            tempItem.comment = parsedData.remarks;
            tempItem.date = securityCheck.SavedAt;
            item.remarks.push(tempItem)
          }
        }
      });

    });

    this.processedRentals = this.processedRentals.map(r => ({
      ...r,
      AIJudgement: [true, false, null][Math.floor(Math.random() * 3)]
    }));

    this.filteredRentals = this.processedRentals;
  }


  public getSecurityCheckCount() {
    this.securityChecks.forEach(securityCheck => {
      if (securityCheck.JsonData && securityCheck.JsonData.trim() !== "") {
        const parsedData = JSON.parse(securityCheck.JsonData);
        for (const obj of parsedData.securityChecks) {
          const { key, ok } = obj;

          if (!this.counters[key]) {
            this.counters[key] = 0;
          }
          if (ok === false) {
            this.counters[key] += 1;
            this.rentalIssues.add(securityCheck.RentalId);
          }
        }
      }      
    });
    this.filteredRentalIssues = this.rentalIssues;
  }

  public async serviceRequestClicked(item: RequestDetails) {
    this.dialogSvc.showServiceRequest(item.Id)
  }

  public async openServiceDialog() {
    var ret = await CreateServiceRequestDialog.open(this.Dialog, this.objectInfo.Id, this.objectInfo.RentalLocation.Id, this.objectInfo, null, true) as unknown as RequestDetails;
    //Checks if the object has the Request already.
    const hasRequestNo = this.objectInfo.ServiceRequests.some(
      x => x.RequestNo === ret.RequestNo
    );
    //If it does not exist, we add it to the list, but first in order.
    if (!hasRequestNo) {
      this.objectInfo.ServiceRequests.unshift(ret);
    }
 
  }

  public openServiceDialogComment(comment: any) {
    CreateServiceRequestDialog.open(this.Dialog, this.objectInfo.Id, this.objectInfo.RentalLocation.Id, this.objectInfo, null, true, comment);
  }

  public async markAsServiceGuy() {
    let result = await this.Api.post<boolean>("Service/RegisterHandleServiceGuy", null, { rentalObjectId: this.data.TrailerId })
    if (result) {
      this.data.HandledSG = true;
    }

  }

  public async markAsCustomerSupport() {
    let result = await this.Api.post<boolean>("Service/RegisterHandleCustomerSupport", null, { rentalObjectId: this.data.TrailerId })
    if (result) {
      this.data.HandledCS = true;
    }

  }

  public async setAIQueueItems(status: number) {
    for (var rental of this.rentalIds) {
      var res = await this.Api.get<boolean>("RentalObject/SetCsSecurityResult", { type: 1, rentalId: rental, input: status });
    }
  }


  public async getBookingWithSpareParts() {

    var result = await this.Api.get<any[]>("/Rental/GetRentalsWithSpareParts", { rentalObjectId: this.data.TrailerId });

    //Maps the object to our RentalSparePart interface.
    if (result.length > 0)
      this.rentalsWithSpareParts = result.map(item => ({ bookingId: item.Item1, spareParts: item.Item2 }));
  }

  public isBookingWithSpareParts(bookingId: number): boolean {
    return this.rentalsWithSpareParts.some(item => item.bookingId == bookingId);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  applyFilter() {
    var selectedGroups: string[] = [];

    selectedGroups = this.groupsControl.value;// Get the selected values from the FormControl

    this.filteredRentals = this.processedRentals.filter(x => selectedGroups.some(y => x.issues.some(z => y == z)));

    if (selectedGroups.length === 0) {
      this.filteredRentals = this.processedRentals;
      this.filteredRentalIssues = this.rentalIssues;
    }

    const filteredRentalIds = this.filteredRentals.map(rental => rental.rentalId);
    this.filteredRentalIssues = new Set<number>(
      [...this.rentalIssues].filter(rentalId => filteredRentalIds.includes(rentalId))
    );

    this.changeDetectorRef.detectChanges();
  }

  public updateBookingSelected(bookingId: number | null): void {
    // Hide the component first by setting both variables to false/null
    this.isBookingSeleceted = false;
    this.bookingSelected = null;

    // Re-show with new id after a short delay to trigger Angular's change detection
    setTimeout(() => {
      if (bookingId != null) {
        this.bookingSelected = bookingId;
        this.isBookingSeleceted = true;
      }
    });
  }

  public processAIInfo() {
    this.aiInformations = [];

    if (!this.data?.AIComments || !Array.isArray(this.data.AIComments)) {
      return;
    }

    for (const raw of this.data.AIComments) {
      if (!raw) continue;

      const info = new AIInfo();

      // RentalId
      const rentalIdMatch = raw.match(/rentalid:\s*(\d+)/i);

      // Comment (with or without quotes)
      const commentMatch = raw.match(/"?comment"?\s*:\s*"?(.*?)"?(?=,\s*"?uncertainty"?|$)/i);

      // Uncertainty (with or without quotes)
      const uncertaintyMatch = raw.match(/"?uncertainty"?\s*:\s*"?(.*?)(?=$|,)/i);

      // should_be_disabled (true/false)
      const disabledMatch = raw.match(/"?Should be disabled"?\s*:\s*(true|false)/i);

      // disable_reason (with or without quotes)
      const disableReasonMatch = raw.match(/"?disableReason"?\s*:\s*"?(.*?)"?(?=,\s*"?manual_inspection_required"?|$)/i);


      if (rentalIdMatch) {
        info.rentalId = Number(rentalIdMatch[1]) || 0;
        this.rentalIds.push(info.rentalId)
      }

      if (commentMatch) {
        info.comment = commentMatch[1].trim();
      }

      if (uncertaintyMatch) {
        info.uncertantyComment = uncertaintyMatch[1].trim();
      }

      if (disabledMatch) {
        info.shouldbeDisabled = disabledMatch[1].trim();
      }

      if (disableReasonMatch) {
        info.disableComment = disableReasonMatch[1].trim();
      }

      this.aiInformations.push(info);
      this.aiInformations.sort((a, b) => b.rentalId - a.rentalId);
      console.log(this.aiInformations);
    }
  }

}

interface RentalsSparePart {
  bookingId: number;
  spareParts: string[];
}


export class Remark{
  comment: string;
  date: moment.Moment; 
}

export class RentalIssues {
  public rentalId: number;
  public rentalStatus: number;
  public issues: string[] = [];
  public remarks: Remark[] = [];
  public pickupDate: moment.Moment;
}



export class AIInfo {
  public rentalId: number;
  public comment: string = "";
  public uncertantyComment: string = "";
  public shouldbeDisabled: boolean;
  public disableComment: string = "";
}
